const toArray = <T,>(value: T[] | null | undefined): T[] => (Array.isArray(value) ? value : [])
const FINDING_TENANT_PRODUCT_ID = 12

const isUnpaidOrder = (order: any): boolean => {
    return toArray<string>(order?.Statuses)
        .some((status) => String(status).trim().toLowerCase() === 'unpaid')
}

const getOrderTimestampForSort = (order: any): number => {
    const updatedAt = Date.parse(String(order?.updatedAt ?? ''))
    if (Number.isFinite(updatedAt)) return updatedAt
    const createdAt = Date.parse(String(order?.createdAt ?? ''))
    if (Number.isFinite(createdAt)) return createdAt
    const orderId = Number(order?.id)
    return Number.isFinite(orderId) ? orderId : 0
}

const isCanceledFindingTenantOrder = (order: any): boolean => {
    return [...toArray<string>(order?.Statuses), order?.ServiceStatus]
        .some((status) => String(status ?? '').trim().toLowerCase() === 'canceled')
}

export const isFindingTenantParentOrder = (order: any): boolean => {
    const productId = Number(order?.ProductID ?? order?.ProductId ?? order?.productID)
    const serviceRef = String(order?.ServiceRef ?? '').trim().toLowerCase()
    return productId === FINDING_TENANT_PRODUCT_ID || serviceRef === 'find_tenant'
}

export const resolveRelatedServicesParentOrder = (orders: any[]): any | undefined => {
    const candidates = toArray<any>(orders).filter((order) => !isUnpaidOrder(order) && isFindingTenantParentOrder(order))
    if (candidates.length === 0) return undefined

    return [...candidates].sort((a, b) => {
        const canceledDiff = Number(isCanceledFindingTenantOrder(a)) - Number(isCanceledFindingTenantOrder(b))
        if (canceledDiff !== 0) return canceledDiff
        const timestampDiff = getOrderTimestampForSort(b) - getOrderTimestampForSort(a)
        if (timestampDiff !== 0) return timestampDiff
        const idDiff = Number(b?.id ?? 0) - Number(a?.id ?? 0)
        if (idDiff !== 0) return idDiff
        return String(b?.id ?? '').localeCompare(String(a?.id ?? ''))
    })[0]
}
